import { render, staticRenderFns } from "./UserClassrooms.vue?vue&type=template&id=f2c7df40&scoped=true"
import script from "./UserClassrooms.vue?vue&type=script&lang=js"
export * from "./UserClassrooms.vue?vue&type=script&lang=js"
import style0 from "./UserClassrooms.vue?vue&type=style&index=0&id=f2c7df40&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2c7df40",
  null
  
)

export default component.exports